export function Forbidden(){
    return <div>
        <h4>403: Access Forbided</h4>
        <div>
            
        </div>
    </div>
}